import Delivery from "components/About/Delivery";

export default Delivery;



// WEBPACK FOOTER //
// ./src/containers/About/Delivery/index.js